import { useState } from "react";
import "./offer.css";
import { useHomeContent } from "../../hooks/useHomeContent";
import { SectionTitle } from "../../../../components/landing/ui/SectionTitle/SectionTitle";

type OfferItem = {
  id?: string;
  title: string;
  icon: string;
};

type OfferTabKey = "products" | "services";

export const Offer = () => {
  const data = useHomeContent();
  const [tab, setTab] = useState<OfferTabKey>("products");

  if (!data?.offer) return null;

  const products = (data.offer.products ?? []) as OfferItem[];
  const services = (data.offer.services ?? []) as OfferItem[];

  const items = tab === "products" ? products : services;

  const title = data.offer.title ?? data.offerTitle ?? "";
  const productsTabLabel = data.offer?.tabs?.products ?? data.offerProducts ?? "";
  const servicesTabLabel = data.offer?.tabs?.services ?? data.offerServices ?? "";
  const tabsAriaLabel = data.offer?.tabsAriaLabel ?? "tabs";

  return (
    <section className="oc-offer oc-section">
      <div className="oc-container">
        <SectionTitle title={title} />

        <div className="oc-offer__tabs" role="tablist" aria-label={tabsAriaLabel}>
          <button
            type="button"
            className={`oc-offer__tab ${tab === "products" ? "is-active" : ""}`}
            onClick={() => setTab("products")}
            role="tab"
            aria-selected={tab === "products"}
          >
            {productsTabLabel}
          </button>

          <button
            type="button"
            className={`oc-offer__tab ${tab === "services" ? "is-active" : ""}`}
            onClick={() => setTab("services")}
            role="tab"
            aria-selected={tab === "services"}
          >
            {servicesTabLabel}
          </button>
        </div>

        <div className="oc-offer__grid" role="tabpanel">
          {items.map((it, idx) => (
            <div key={it.id ?? `${it.title}-${idx}`} className="oc-offer__card">
              <div className="oc-offer__iconWrap" aria-hidden="true">
                <img className="oc-offer__icon" src={it.icon} alt="" />
              </div>

              <div className="oc-offer__title">{it.title}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
